export default {
  common: {
    actions: {
      cancel: 'CANCEL',
      delete: 'DELETE',
      edit: 'EDIT',
      save: 'SAVE',
      send: 'SEND',
      prompt: 'Are you sure?'
    },
    errors: {
      save_failed: 'SAVING FAILED'
    },
    credits: 'Credits',
    next_training: 'Next training',

    // These are deliberately in Dutch at the time of writing as requested by TIFA
    sub_end_warning_day_one: 'Het abonnement verloopt over {{count}} dag.',
    sub_end_warning_day_other: 'Het abonnement verloopt over {{count}} dagen.',
    sub_end_warning_week: 'Het abonnement verloopt over {{count}} weken.',
    sub_end_warning_message: ' Neem contact op met TIFA Sports om te verlengen en door te ontwikkelen!'
  },

  household: {
    title: 'My family',
    pick_child: 'Choose a child',
    pending_title: 'Registration received',
    pending_text: 'TIFA Sports is reviewing your registration and will assign a group and subscription soon. You will be notified. Until then you cannot book yet.',
    no_group: 'No group yet',
    switch_child: 'Switch child',
    delete_account: 'Delete account',
    delete_confirm: 'Are you sure you want to delete your account?',
    deleted: 'Your account and your children\'s data have been deleted.',
    delete_requested: 'Your request has been sent. TIFA Sports will delete your account within 30 days and will contact you if anything is still open.',
  },

  signup: {
    link: 'New at TIFA? Create an account',
    intro: 'Enter your e-mail address. You will receive a link to create your account and your child(ren)\'s.',
    send: 'Send link',
    sent: 'Check your e-mail: we sent you a link (valid for 1 hour).',
    mail_exists: 'This e-mail address already has an account. Log in or use "Forgot password".',
    title: 'Create account',
    parent: 'Your details',
    children: 'Children',
    child: 'Child',
    add_child: '+ Another child',
    remove_child: 'Remove',
    pass: 'Password (at least 8 characters)',
    pass_check: 'Repeat password',
    pass_mismatch: 'The passwords do not match',
    consent_terms: 'I agree to the TIFA Sports privacy policy',
    privacy_link: 'Read the privacy policy',
    consent_photos: 'TIFA Sports may take photos of my child(ren) during trainings and tournaments',
    submit: 'Create account',
    expired: 'This link has expired or was already used. Request a new one via "Create an account".',
    error: 'Registration failed',
    errors: {
      missing_parent_name: 'Enter your first name',
      pass_too_short: 'The password needs at least 8 characters',
      missing_consent: 'Please agree to the privacy policy',
      children_count: 'Enter at least 1 child (at most 6)',
      missing_child_name: 'Enter the first name of each child',
      invalid_birth_date: 'Check the date of birth',
      mail_exists: 'This e-mail address already has an account',
      signup_expired: 'This link has expired. Request a new one.',
    }
  },

  trial: {
    title: 'Free trial training',
    intro: 'Join a training at TIFA PARC in Rotterdam, free of charge. Choose the programme, a moment and fill in your details.',
    step_program: 'Programme',
    step_moment: 'Moment',
    step_details: 'Details',
    programs: { peuter: 'Toddler football', fundament: 'TIFA Fundament', institute: 'TIFA Sports Institute' },
    no_slots: 'No spots available in the coming weeks. Call or e-mail us and we will find a moment together.',
    full: 'Full',
    left_one: '{{count}} spot left',
    left_other: '{{count}} spots left',
    child_name: 'Name of your child',
    parent_name: 'Your name',
    message: 'Note (optional)',
    consent: 'I agree that TIFA Sports uses these details for the trial training',
    submit: 'Request trial training',
    done_title: 'See you on the pitch!',
    done_text: 'We sent a confirmation to {{email}}. Bring sportswear, football boots or trainers and water.',
    back: 'Back to the app',
    link: 'Book a free trial training',
    error: 'Something went wrong. Please try again or call us.',
    errors: {
      already_requested: 'You already requested a trial training. Want another moment? Reply to the confirmation e-mail.',
      busy: 'It is very busy. Please try again tomorrow or call us.',
      slot_full: 'This moment just filled up. Please choose another one.',
      invalid_slot: 'This moment is no longer available. Please choose another one.',
      invalid_email: 'Check the e-mail address',
      missing_phone: 'Enter your phone number',
      missing_consent: 'Please agree to continue',
      invalid_birth_date: 'Check the date of birth',
      missing_child_name: 'Enter the name of your child',
      missing_parent_name: 'Enter your name',
    }
  },

  login: {
    change_pass: 'Change password',
    confirm_change_pass: `If the email address is known, you've received a recovery mail`,
    forgot_pass: 'Forgot password?',
    go_back: 'Back to login',
    persist: 'Stay logged in',
  },

  user: {
    fields: {
      name: 'FIRST NAME',
      last_name: 'LAST NAME',
      birth_date: 'DATE OF BIRTH',
      phone_nr: 'PHONE NUMBER',
      team: 'CLUB / TEAM',
      language: {
        _label: 'LANGUAGE',
        en: 'English',
        nl: 'Nederlands'
      },
      avatar: 'PROFILE PICTURE',
    },
    change_pass: 'CHANGE PASSWORD',
  },
  
  slot: {
    label: 'BOOKINGS',

    actions: {
      book: 'BOOK SLOT',
      cancel: 'CANCEL SLOT'
    },

    available: 'SLOTS',
    booked: 'BOOKED',
    no_refund: 'Your credit will not be refunded'
  },

  video: {

  },

  rules: {

  },

  feedback: {
    fields: {
      type: {
        _label: '',
        _empty: 'Choose a category...',
        Bug: 'Bug',
        Design: 'Design',
        Functionaliteit: 'Functionality',
        Overig: 'Other...'
      }
    },
    descriptions: {
      Bug: 'Did you discover a problem in the app? Please let us know - as clearly as possible - what happened, and what you expected would happen instead',
      Design: 'Do you have any design tips? Let us know how we can improve!',
      Functionaliteit: 'Is anything missing, or do you have tips on how to improve functionalities? Please let us know!',
      Overig: 'Do you have any tips or suggestions? Let us know!'
    },

    type_choice: 'Choose a kind of feedback:',
    reload_description: 'New feature not available yet?',
    reload_text: 'RELOAD THE APP',
    thanks_text: 'Thanks for your feedback!',
    error_text: 'Something went wrong sending your feedback; please let us know via info@tifasports.com'
  },

  categories: {
    label: 'Categories',
    hero_text: {
      flash: 'A player who wants to get to the Hulk category at lightning speed',
      batman: 'Players of 4 and 5 years old',
      hulk: 'A player that plays below 1st division in Europe, amateur',
      black_panther: 'A player that plays at 1st division in Europe, academy and high level amateur',
      wolverine: 'A player that plays at the Superleague in The Netherlands, academy',
      spiderman: 'A top player that plays at Feyenoord, Ajax, PSV, AZ in the Superleague, academy',
      iron_man: 'A top player that plays for the national team, academy'
    }
  },

  about: {
    label: 'About us...'
  }
}

